import React from 'react';
import { PropTypes } from 'prop-types';
import './plaza.scss';

export const PlazaList = ({ topics }) => (
  <ul className='topicList'>
    {topics.map((topic, i) => (
      <li className='topicItem' key={topic.name}>
        <span
          className='topicBullet'
          style={{ backgroundColor: topic.color }}
        />
        {topic.name}
      </li>
    ))}
  </ul>
);

PlazaList.propTypes = {
  topics: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string,
      name: PropTypes.string
    })
  )
};

export default PlazaList;
